import React, { useEffect, useState } from "react";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import { Typography, DatePicker, Table, TreeSelect, Badge, Spin } from "antd";
import { errorHandle, openNotificationWithIcon } from "../../Function";
import moment from "moment";
import { useSelector } from "react-redux";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import { ListBoPhanApi } from "../../../api/getListTeam";
import {
  GetDataOvertimeHRApi,
  SubmitDataOvertimeHRApi,
} from "../../../api/getOvertime";
import { DownloadTongHopOTNSApi } from "../../../api/getInfoData";
import ModalDetailItem from "./Overtime/Modals/ModalDetailItem";

const { Link } = Typography;

const getHeader = (data, date) => {
  return (
    <span>
      {new Date(data).getDay() === 0
        ? "CN"
        : "Thứ " + (new Date(data).getDay() + 1)}
      <br />
      {moment(data).format("DD")}
    </span>
  );
};

const RenderItemRow = (
  text,
  record,
  updateData,
  currentDate,
  setIsShowDetailItem,
  setCurrentItem,
  setCurrentDateSelected
) => {
  return (
    <div style={{ textAlign: "center", width: "100%" }}>
      {text ? (
        <RenderSingleInnerItem
          record={record}
          text={text}
          currentDate={currentDate}
          setIsShowDetailItem={setIsShowDetailItem}
          setCurrentItem={setCurrentItem}
          setCurrentDateSelected={setCurrentDateSelected}
        />
      ) : (
        "-"
      )}
    </div>
  );
};

const RenderSingleInnerItem = ({
  record,
  text,
  currentDate,
  setIsShowDetailItem,
  setCurrentItem,
  setCurrentDateSelected,
}) => {
  const onShowDetailItem = () => {
    setCurrentDateSelected(currentDate);
    setCurrentItem(record);
    setIsShowDetailItem(true);
  };
  const timeRanges = String(text).includes("&&")
    ? String(text).split("&&")
    : [text];

  return (
    <div
      onClick={text.type !== "offDate" ? onShowDetailItem : null}
      style={{ width: "100%" }}
    >
      <div>{timeRanges[0]}</div>
      <div>{timeRanges.length === 2 && timeRanges[1]}</div>
    </div>
  );
};

const getStyleColorOT = (item) => {
  let result;
  if (item.type === "Error") {
    result = "#FFCAAF";
  } else {
    switch (item.trangthaiDuyet__sortDuyet) {
      case 4:
        result = "red";
        break;
      case 3:
        result = "#75ef42";
        break;
      case 5:
        result = "#31ecd0";
        break;
      case 6:
        result = "#ec238a";
        break;
      case 2:
        result = "#4ca4f1";
        break;
      default:
        result = "#ffffff";
        break;
    }
  }

  return result || "";
};

export const OvertimeNhanSu = () => {
  const defaultPageSize = 10;
  const [data, setData] = useState([]);
  const [lsDate, setLsDate] = useState([]);
  const [lsTeam, setLsTeam] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lsMemberId, setLsMemberId] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [currentTeam, setCurrentTeam] = useState([]);
  const [currentItem, setCurrentItem] = useState({});
  const [currentSelectedDate, setCurrentSelectedDate] = useState(
    moment(new Date())
  );
  const [currentDateSelected, setCurrentDateSelected] = useState(null);
  const [columns, setColumns] = useState([]);
  const [isShowDetailItem, setIsShowDetailItem] = useState(false);
  const systemGroup = useSelector((state) => state.systemInfo.systemGroup);
  const [isValid, setIsValid] = useState(true);
  const userInfo = useSelector((state) => state.getUserInfo.userInfo);

  const [lsBoPhan, setLsBoPhan] = useState([]);
  const [currentBoPhan, setCurrentBoPhan] = useState([]);
  const [treeDataBoPhan, setTreeDataBoPhan] = useState([]);
  const [lsAllTeam, setLsAllTeam] = useState([]);
  const [loading_page, setLoading_page] = useState(false);

  const onSubmitOT = (type) => {
    SubmitDataOvertimeHRApi({
      idTeam: JSON.stringify(currentTeam),
      thoiGian: currentSelectedDate.format("YYYYMM"),
      type: type,
    })
      .then((r) => {
        openNotificationWithIcon("success", "Thành công", "");
        updateData();
      })
      .catch((err) => {
        errorHandle(err);
      });
  };

  const GetLsButton = ({ permissions, systemGroup, teamPermissions, data }) => {
    const maxGroup = new Set(systemGroup.map((item) => item.group)).size;
    const BtnPd = () => (
      <Button
        ghost
        type="success"
        className={"m-2"}
        onClick={() => onSubmitOT("accept_approval")}
        icon={<CheckOutlined />}
      >
        Phê duyệt
      </Button>
    );
    const BtnGuiTra = () => (
      <Button
        ghost
        type="danger"
        className={"m-2"}
        onClick={() => onSubmitOT("refuse_approval")}
        icon={<CloseOutlined />}
      >
        Gửi trả
      </Button>
    );

    if (data.length === 0) {
      return [];
    }

    const arrTeam = teamPermissions.map(
      (item, index) => item.phanquyen__ten_pq
    );
    const uniqueArrTeam = [...new Set(arrTeam)];
    let results = [];
    // if (lsDate[lsDate.length-1] > new Date()) {
    //     return results;
    // }
    switch (maxGroup) {
      case 4:
        if (uniqueArrTeam.includes("overtime_ns_accept")) {
          results.push(<BtnPd />);
        }
        if (uniqueArrTeam.includes("overtime_ns_reject")) {
          results.push(<BtnGuiTra />);
        }
    }
    return results.map((item, index) => <span key={index}>{item}</span>);
  };

  const getStyleColorOT = (item) => {
    let result;
    if (item.type === "Error") {
      result = "#FFCAAF";
    } else {
      switch (item.trangthaiDuyet__sortDuyet) {
        // case 1:
        case 4:
          result = "red";
          break;
        case 3:
          result = "#75ef42";
          break;
        case 5:
          result = "#31ecd0";
          break;
        case 6:
          result = "#ec238a";
          break;
        case 2:
          result = "#4ca4f1";
          break;
        default:
          result = "#ffffff";
          break;
      }
    }

    return result || "";
  };

  const mapDataLichOT = (data) => {
    let results = [];
    let lsMemberId = [];
    let lsIdOTTemp = [];
    let isValid = true;
    for (let i of data) {
      if (i.data.length === 0) {
        continue;
      }
      lsMemberId.push(i.id);
      let obj = {};
      obj.nhanvien = i.msnv + "-" + i.username;
      obj.id = i.id;
      obj.total_minot = i.tongPhut;
      obj.total_hourot = i.tongGio;
      obj.total_congot = i.tongCongOT;
      obj.status = i.status;
      for (let k of i.data) {
        if (k.type === "Error") {
          isValid = false;
        }
        lsIdOTTemp.push(k.id);
        obj["col" + moment(k.ngay, "YYYY-MM-DD").format("DDMM")] = k;
        obj["time_regist_" + moment(k.ngay, "YYYY-MM-DD").format("DDMM")] =
          (k.gio_vao_1 !== null
            ? moment(k.gio_vao_1, "HH:mm:ss").format("HH:mm")
            : "") +
          (k.gio_vao_1 !== null && k.gio_ra_1 !== null ? " - " : "") +
          (k.gio_ra_1 !== null
            ? moment(k.gio_ra_1, "HH:mm:ss").format("HH:mm")
            : "") +
          (k.gio_vao_1 !== null &&
          k.gio_ra_1 !== null &&
          k.gioVaoDK !== null &&
          k.gioRaDK !== null
            ? "&&"
            : "") +
          (k.gioVaoDK !== null
            ? moment(k.gioVaoDK, "HH:mm:ss").format("HH:mm")
            : "") +
          (k.gioVaoDK !== null && k.gioRaDK !== null ? " - " : "") +
          (k.gioRaDK !== null
            ? moment(k.gioRaDK, "HH:mm:ss").format("HH:mm")
            : "");
        obj["time_actual_" + moment(k.ngay, "YYYY-MM-DD").format("DDMM")] =
          (k.gioVaoTT != ""
            ? moment(k.gioVaoTT, "HH:mm:ss").format("HH:mm")
            : "") +
          " - " +
          (k.gioRaTT != ""
            ? moment(k.gioRaTT, "HH:mm:ss").format("HH:mm")
            : "");
        obj["time_system_" + moment(k.ngay, "YYYY-MM-DD").format("DDMM")] =
          (k.gioVaoHT != ""
            ? moment(k.gioVaoHT, "HH:mm:ss").format("HH:mm")
            : "") +
          " - " +
          (k.gioRaHT != ""
            ? moment(k.gioRaHT, "HH:mm:ss").format("HH:mm")
            : "");
        obj["mins_" + moment(k.ngay, "YYYY-MM-DD").format("DDMM")] = k.soPhut;
      }
      results.push(obj);
    }
    setIsValid(isValid);
    // setLsIdOT(lsIdOTTemp);

    return [results, lsMemberId];
  };

  const mapColumnLichOT = (data1) => {
    // lấy danh sách ngày OT của user để tạo columns
    let columns_date = [];
    let ls_date = [];
    data1.map(({ data }) => {
      data.map((item) => {
        ls_date.push(moment(item.ngay, "YYYY-MM-DD"));
      });
    });
    // ls_date = [...new Set(ls_date)];
    const comparisonValues = ls_date.map((v) => v.valueOf());
    ls_date = ls_date.filter(
      (v, i) => comparisonValues.indexOf(v.valueOf()) == i
    );
    ls_date.sort((a, b) => a.diff(b));
    for (let i of ls_date) {
      let columns_detail = {};
      let currentDate = i.format("DDMM");
      columns_detail["title"] = getHeader(i, lsDate);
      columns_detail["dataIndex"] = "col" + currentDate;
      columns_detail["key"] = "col" + currentDate;
      columns_detail["filterKey"] = "col" + currentDate;
      columns_detail["type"] = "text";
      columns_detail["align"] = "center";
      columns_detail["canSearch"] = true;
      columns_detail["color"] = "red";
      columns_detail["children"] = [
        {
          title: "Giờ Đăng Ký",
          dataIndex: "time_regist_" + i.format("DDMM"),
          key: "time_regist_" + i.format("DDMM"),
          align: "center",
          className: "hoverBlur",
          width: 100,
          render: (text, record) => {
            return {
              props: {
                style: {
                  borderRadius: 0,
                  background: record["col" + currentDate]
                    ? getStyleColorOT(record["col" + currentDate])
                    : "",
                },
              },
              children: (
                <div>
                  {RenderItemRow(
                    text,
                    record,
                    updateData,
                    currentDate,
                    setIsShowDetailItem,
                    setCurrentItem,
                    setCurrentDateSelected
                  )}
                </div>
              ),
            };
          },
        },

        {
          title: "Giờ Thực Tế",
          dataIndex: "time_actual_" + i.format("DDMM"),
          key: "time_actual_" + i.format("DDMM"),
          className: "hoverBlur",
          align: "center",
          width: 100,
          render: (text, record) => {
            return {
              props: {
                style: {
                  borderRadius: 0,
                  background: record["col" + currentDate]
                    ? getStyleColorOT(record["col" + currentDate])
                    : "",
                },
              },
              children: (
                <div>
                  {RenderItemRow(
                    text,
                    record,
                    updateData,
                    currentDate,
                    setIsShowDetailItem,
                    setCurrentItem,
                    setCurrentDateSelected
                  )}
                </div>
              ),
            };
          },
        },
        {
          title: "Số Phút",
          className: "hoverBlur",
          dataIndex: "mins_" + i.format("DDMM"),
          key: "mins_" + i.format("DDMM"),
          align: "center",
          width: 100,
          render: (text, record) => {
            return {
              props: {
                style: {
                  borderRadius: 0,
                  background: record["col" + currentDate]
                    ? getStyleColorOT(record["col" + currentDate])
                    : "",
                },
              },
              children: (
                <div>
                  {RenderItemRow(
                    text,
                    record,
                    updateData,
                    currentDate,
                    setIsShowDetailItem,
                    setCurrentItem,
                    setCurrentDateSelected
                  )}
                </div>
              ),
            };
          },
        },
      ];
      columns_date.push(columns_detail);
    }
    const columns_first = [
      {
        title: "Nhân Viên",
        dataIndex: "nhanvien",
        key: "nhanvien",
        className: "highlight",
        filterKey: "nhanvien",
        type: "text",
        align: "center",
        width: 100,
        canSearch: true,
        fixed: "left",
      },
    ];

    const columns_last = [
      {
        title: "Tổng Phút OT",
        dataIndex: "total_minot",
        key: "total_minot",
        className: "highlight",
        filterKey: "total_minot",
        align: "center",
        type: "text",
        canSearch: true,
        width: 50,
        fixed: "right",
      },
      {
        title: "Tổng Giờ OT",
        dataIndex: "total_hourot",
        key: "total_hourot",
        filterKey: "total_hourot",
        className: "highlight",
        align: "center",
        type: "text",
        canSearch: true,
        width: 50,
        fixed: "right",
      },
      {
        title: "Tổng Công OT",
        dataIndex: "total_congot",
        key: "total_congot",
        filterKey: "total_congot",
        className: "lastColumn highlight",
        align: "center",
        type: "text",
        canSearch: true,
        width: 50,
        fixed: "right",
      },
    ];

    let columns = [...columns_first, ...columns_date, ...columns_last];

    return columns;
  };

  const fetchData = (params = {}) => {
    setLoading(true);
    const date = params.date || currentSelectedDate;
    const firstDayOfMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      1
    );
    const lastDayOfMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth() + 1,
      0
    );
    GetDataOvertimeHRApi({
      idTeam: params.idTeam, 
      tuNgay: moment(firstDayOfMonth).format("YYYYMMDD"),
      denNgay: moment(lastDayOfMonth).format("YYYYMMDD"),
    })
      .then((r) => {
        const newData = mapDataLichOT(r.data);
        const newColumns = mapColumnLichOT(r.data);
        setData(newData[0]);
        setLsMemberId(newData[1]);
        setColumns(newColumns);
        setLoading(false);
      })
      .catch((err) => {
        errorHandle(err);
        setLoading(false);
      });
  };

  const fetchListTeam = () => {
    ListBoPhanApi().then((res) => {
      const arrTeam = userInfo.team_permissions
        .filter((item) => item.phanquyen__ten_pq === "overtime_ns")
        .map((item, index) => {
          const idBoPhanForTeam = res.data.filter((itemBP) =>
            itemBP.team.some((itemT) => itemT.id == item.team)
          );
          if (idBoPhanForTeam.length != 0) {
            return {
              idTeam: item.team,
              team: item.team__tenTeam,
              idBoPhan: idBoPhanForTeam[0].id,
            };
          }
          return false;
        })
        .filter((item) => item != false);
      const uniqueArrTeam = [
        ...new Map(arrTeam.map((item) => [item["idTeam"], item])).values(),
      ];
      uniqueArrTeam.sort(function (first, second) {
        return first["idTeam"] - second["idTeam"];
      });
      const arrIdTeam = uniqueArrTeam.map((item) => item.idTeam);
      const arrBoPhan = res.data.filter(({ team }) =>
        team.some((item) => arrIdTeam.includes(item.id))
      );
      if (arrBoPhan.length > 0) {
        setCurrentBoPhan([arrBoPhan[0].id]);
      }
      setLsBoPhan(arrBoPhan);

      setLsAllTeam(uniqueArrTeam);
      if (currentTeam.length === 0) {
        setCurrentTeam([
          arrIdTeam.filter((x) =>
            arrBoPhan[0].team.map((item) => item.id).includes(x)
          )[0],
        ]); // 200423 lấy element đầu tiên đặt trong list
      }
      setLsTeam(
        uniqueArrTeam.filter((x) =>
          arrBoPhan[0].team.map((item) => item.id).includes(x.idTeam)
        )
      );
    });
  };

  useEffect(() => {
    if (currentTeam.length > 0) {
      fetchData({
        idTeam: JSON.stringify(currentTeam),
        thoiGian: moment(currentSelectedDate),
      });
    }
    if (currentTeam.length === 0) {
      setData([{}]);
    }
  }, [currentSelectedDate, currentTeam]);

  useEffect(() => {
    if (
      userInfo &&
      userInfo.team_permissions &&
      userInfo.team_permissions.length > 0
    ) {
      fetchListTeam();
    }
  }, [userInfo]);

  const updateData = () => {
    fetchData({
      idTeam: JSON.stringify(currentTeam),
      thoiGian: moment(currentSelectedDate),
    });
  };

  const onChangeBoPhan = (value) => {
    if (value.length > 0) {
      setCurrentBoPhan(value);
      const lsTeamWith_BP = lsAllTeam.filter((x) => value.includes(x.idBoPhan));
      setLsTeam(lsTeamWith_BP);
      setCurrentTeam([lsTeamWith_BP.map((item) => item.idTeam)[0]]); // 200423
    } else {
      setLsTeam([]);
      setCurrentBoPhan([]);
      setCurrentTeam([]);
    }
  };

  const tPropsConfig_BoPhan = {
    treeData: [
      {
        title:
          currentBoPhan.length > 0 ? (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBoPhan([]);
                }
              }}
              className="style_SelectTeam"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBoPhan(lsBoPhan.map((item) => item.id));
                }
              }}
              className="style_SelectTeam"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeDataBoPhan,
    ],
    value: treeDataBoPhan.length > 0 ? currentBoPhan : undefined,
    onChange: onChangeBoPhan,
    treeCheckable: true,
    // showCheckedStrategy: SHOW_PARENT,
    maxTagCount: 2,
    placeholder: "Chọn bộ phận",
    style: { width: "fit-content", minWidth: 200 },
    disabled: loading,
  };

  useEffect(() => {
    const treeDataBoPhan = lsBoPhan.map((item) => {
      return { title: item.tenBophan, value: item.id, key: item.id };
    });
    setTreeDataBoPhan(treeDataBoPhan);
    if (currentBoPhan.length === 0) {
      setCurrentBoPhan(lsBoPhan.map((item) => item.id));
    }
  }, [lsBoPhan]);

  const onChangeTeam = (value) => {
    if (value.length > 0) {
      setCurrentTeam(value);
    } else {
      setCurrentTeam([]);
    }
  };

  const tPropsConfig = {
    treeData: [
      {
        title:
          currentTeam.length > 0 ? (
            <span
              onClick={() => setCurrentTeam([])}
              className="style_SelectTeam"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => setCurrentTeam(lsTeam.map((item) => item.idTeam))}
              className="style_SelectTeam"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeData,
    ],
    value: treeData.length > 0 ? currentTeam : undefined,
    onChange: onChangeTeam,
    treeCheckable: true,
    // showCheckedStrategy: SHOW_PARENT,
    maxTagCount: 2,
    placeholder: "Chọn team",
    style: { width: "fit-content", minWidth: 200 },
    disabled: loading,
  };

  useEffect(() => {
    const treeDataTemp = lsTeam.map((item) => {
      return {
        title: (
          <span
            onClick={() => {
              return loading && false;
            }}
          >
            {item.team}
          </span>
        ),
        value: item.idTeam,
        key: item.idTeam,
      };
    });
    setTreeData(treeDataTemp);
  }, [lsTeam]);

  const onChangeMonth = (date) => {
    setCurrentSelectedDate(date);
  };

  const onQuickChangeMonth = (type) => {
    let monthChange;
    if (type === "previous") {
      monthChange = moment(currentSelectedDate).subtract(1, "month");
    } else {
      monthChange = moment(currentSelectedDate).add(1, "month");
    }
    setCurrentSelectedDate(monthChange);
  };

  function disabledMonth(current) {
    // Can not select days after today and today
    const currentDate = new Date();
    return (
      current &&
      current >
        moment(
          new Date(currentDate.getFullYear(), currentDate.getMonth()),
          0
        ).endOf("day")
    );
  }

  const fileDownload_TongHopOTNS = () => {
    const fnFileDownload = require("js-file-download");
    const filename =
      "BangTongHopTangCa_" +
      moment(new Date()).format("YYYYMMDDHHMMSS") +
      ".xlsx";
    setLoading_page(true);

    const date = moment(currentSelectedDate);
    const firstDayOfMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      1
    );
    const lastDayOfMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth() + 1,
      0
    );

    DownloadTongHopOTNSApi({
      idTeam: JSON.stringify(currentTeam),
      tuNgay: moment(firstDayOfMonth).format("YYYYMMDD"),
      denNgay: moment(lastDayOfMonth).format("YYYYMMDD"),
    })
      .then((res) => {
        fnFileDownload(res.data, filename);
        setLoading_page(false);
        openNotificationWithIcon("success", "Tải file thành công", "");
      })
      .catch((error) => {
        console.log(error);
        openNotificationWithIcon(
          "error",
          "Lỗi",
          "Chưa có danh sách tăng ca hoặc chưa phê duyệt"
        );
        // errorHandle(error);
        setLoading_page(false);
      });
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">Tổng hợp tăng ca thường</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link href="#">Nhân sự</Link>
                </li>
                <li className="breadcrumb-item active">Tổng hợp tăng ca</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div
          className={
            "col-12 mb-2 d-sm-flex align-items-center justify-content-between"
          }
        >
          <div className={"col"}>
            <Button
              type="primary"
              className={"m-2 styleNtn_1"}
              onClick={() => onQuickChangeMonth("previous")}
              title="Tuần trước"
            >
              <i className={"fa fa-arrow-left"}></i>
            </Button>
            {new Date(currentSelectedDate).getTime() <
              new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                1
              ).getTime() && (
              <Button
                type="primary"
                className={"m-2 styleNtn_1"}
                onClick={() => onQuickChangeMonth("next")}
                title="Tháng sau"
              >
                <i className={"fa fa-arrow-right"}></i>
              </Button>
            )}
            <DatePicker
              disabledDate={disabledMonth}
              style={{ borderRadius: 10 }}
              className={"m-2"}
              disabled={loading}
              onChange={onChangeMonth}
              picker={"month"}
              value={currentSelectedDate}
              format={"MM/YYYY"}
              allowClear={false}
            />

            <div className="styleBadge">
              <Badge.Ribbon
                text="Bộ phận"
                color="gray"
                style={{ color: "red" }}
              >
                <TreeSelect {...tPropsConfig_BoPhan} />
              </Badge.Ribbon>
            </div>
            <div className="styleBadge">
              <Badge.Ribbon text="Team" color="gray" style={{ color: "red" }}>
                <TreeSelect {...tPropsConfig} />
              </Badge.Ribbon>
            </div>
            {userInfo &&
              userInfo.team_permissions &&
              systemGroup &&
              systemGroup.length > 0 &&
              currentTeam.length > 0 && (
                <GetLsButton
                  permissions={userInfo.user_permissions}
                  systemGroup={systemGroup}
                  teamPermissions={userInfo.team_permissions}
                  data={data}
                />
              )}
          </div>
          <div>
            <Button
              type={"danger"}
              className={"m-2 btnGreen"}
              style={{ marginRight: 5 }}
              onClick={fileDownload_TongHopOTNS}
            >
              Tải xuống
            </Button>
          </div>
        </div>
      </div>
      <Spin spinning={loading_page}>
        <div className="row">
          <Table
            dataSource={data}
            columns={columns}
            loading={loading}
            bordered={true}
            scroll={{ x: 1920, y: 500 }}
            size={"small"}
            rowKey="id"
            className={"custom-table-hover style-6"}
            pagination={false}
          />
        </div>
      </Spin>
      <ModalDetailItem
        visible={isShowDetailItem}
        onCancel={() => setIsShowDetailItem(false)}
        itemDetail={currentItem}
        currentDate={currentDateSelected}
        updateData={updateData}
      />
    </>
  );
};
